import { combineReducers } from 'redux';
import { navbarReducer } from '../../components/navbar/reducers/navbarReducer';
import { loginReducer } from './components/loginForm/reducers/loginReducer';

export default combineReducers({
  'navbar': navbarReducer,
  'login': loginReducer
});



// WEBPACK FOOTER //
// ./src/pages/login/rootReducers.js